<template>
    <div class="share-footer">
      <div id="my-qrcode" style="margin: 0 auto; width: 80px; height: 80px;"></div>
      <img src="@/assets/rqCode.png" style="display: block; margin: 15px auto 20px; width: 130px;" />
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props: {
    matchId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {

    };
  },
  mounted() {
    let url = ''
    if (process.env.VUE_APP_ENV === 'dev') {
      url = 'https://www.snsports.cn/match-h5-dev/index.html#/match/home?matchId=' + this.matchId
    } else {
      url = 'https://www.snsports.cn/match-h5/index.html#/match/home?matchId=' + this.matchId
    }
    new QRCode('my-qrcode', {
      width: 80,
      height: 80,
      text: url
    })
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.share-footer{
  margin-top: 12px;
  img{
    
  }
}
</style>
